module.exports = __webpack_public_path__ + "static/img/4.08d499b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/eng/4.png
// module id = 2qO8
// module chunks = 0